import "./i18n";
import "./styles/app-base.css";
import "./styles/app-components.css";
import "./styles/app-utilities.css";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { registerServiceWorker } from "./app/utils/serviceWorkerRegistration";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://3411aae930a14e3908017b83bd2c4084@o4506783720144896.ingest.us.sentry.io/4509808322412544",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/biodit\.com\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true,
});

// import * as serviceWorker from './serviceWorker';
// import reportWebVitals from './reportWebVitals';

/**
 * The root element of the application.
 */
const container = document.getElementById("root");

if (!container) {
  throw new Error("Failed to find the root element");
}

/**
 * The root component of the application.
 */
const root = createRoot(container);

root.render(<App />);

// Register Firebase service worker first, then PWA service worker
if ("serviceWorker" in navigator) {
  // Register Firebase service worker for FCM
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js", {
      scope: "/",
      updateViaCache: "none",
    })
    .then((registration) => {
      console.log("Firebase service worker registered:", registration.scope);
    })
    .catch((error) => {
      console.error("Firebase service worker registration failed:", error);
    });

  // Then register PWA service worker
  registerServiceWorker();
}

{
  /* <RequiredAuthProvider
        authUrl={process.env.REACT_APP_AUTH_URL}
        displayWhileLoading={<Loading />}
        displayIfLoggedOut={<RedirectToLogin />}
    >
        <YourApp />
    </RequiredAuthProvider>, */
}

// reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
